export default __webpack_public_path__ + "static/media/dk.eb689ae6.webp";